/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service.crossref
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: cross_reference.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as cross_reference_pb from './cross_reference_pb'; // proto import: "cross_reference.proto"


export class CrossReferenceServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorBuildCrossReferenceGraph = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildCrossReferenceGraph',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.BuildCrossReferenceGraphRequest,
    cross_reference_pb.BuildCrossReferenceGraphResponse,
    (request: cross_reference_pb.BuildCrossReferenceGraphRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.BuildCrossReferenceGraphResponse.deserializeBinary
  );

  buildCrossReferenceGraph(
    request: cross_reference_pb.BuildCrossReferenceGraphRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.BuildCrossReferenceGraphResponse>;

  buildCrossReferenceGraph(
    request: cross_reference_pb.BuildCrossReferenceGraphRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.BuildCrossReferenceGraphResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.BuildCrossReferenceGraphResponse>;

  buildCrossReferenceGraph(
    request: cross_reference_pb.BuildCrossReferenceGraphRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.BuildCrossReferenceGraphResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildCrossReferenceGraph',
        request,
        metadata || {},
        this.methodDescriptorBuildCrossReferenceGraph,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildCrossReferenceGraph',
    request,
    metadata || {},
    this.methodDescriptorBuildCrossReferenceGraph);
  }

  methodDescriptorGetCrossReferenceGraph = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossReferenceGraph',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.GetCrossReferenceGraphRequest,
    cross_reference_pb.GetCrossReferenceGraphResponse,
    (request: cross_reference_pb.GetCrossReferenceGraphRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.GetCrossReferenceGraphResponse.deserializeBinary
  );

  getCrossReferenceGraph(
    request: cross_reference_pb.GetCrossReferenceGraphRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.GetCrossReferenceGraphResponse>;

  getCrossReferenceGraph(
    request: cross_reference_pb.GetCrossReferenceGraphRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetCrossReferenceGraphResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.GetCrossReferenceGraphResponse>;

  getCrossReferenceGraph(
    request: cross_reference_pb.GetCrossReferenceGraphRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetCrossReferenceGraphResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossReferenceGraph',
        request,
        metadata || {},
        this.methodDescriptorGetCrossReferenceGraph,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossReferenceGraph',
    request,
    metadata || {},
    this.methodDescriptorGetCrossReferenceGraph);
  }

  methodDescriptorBuildElementRegistry = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildElementRegistry',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.BuildElementRegistryRequest,
    cross_reference_pb.BuildElementRegistryResponse,
    (request: cross_reference_pb.BuildElementRegistryRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.BuildElementRegistryResponse.deserializeBinary
  );

  buildElementRegistry(
    request: cross_reference_pb.BuildElementRegistryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.BuildElementRegistryResponse>;

  buildElementRegistry(
    request: cross_reference_pb.BuildElementRegistryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.BuildElementRegistryResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.BuildElementRegistryResponse>;

  buildElementRegistry(
    request: cross_reference_pb.BuildElementRegistryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.BuildElementRegistryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildElementRegistry',
        request,
        metadata || {},
        this.methodDescriptorBuildElementRegistry,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/BuildElementRegistry',
    request,
    metadata || {},
    this.methodDescriptorBuildElementRegistry);
  }

  methodDescriptorGetElementRegistry = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetElementRegistry',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.GetElementRegistryRequest,
    cross_reference_pb.GetElementRegistryResponse,
    (request: cross_reference_pb.GetElementRegistryRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.GetElementRegistryResponse.deserializeBinary
  );

  getElementRegistry(
    request: cross_reference_pb.GetElementRegistryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.GetElementRegistryResponse>;

  getElementRegistry(
    request: cross_reference_pb.GetElementRegistryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetElementRegistryResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.GetElementRegistryResponse>;

  getElementRegistry(
    request: cross_reference_pb.GetElementRegistryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetElementRegistryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetElementRegistry',
        request,
        metadata || {},
        this.methodDescriptorGetElementRegistry,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetElementRegistry',
    request,
    metadata || {},
    this.methodDescriptorGetElementRegistry);
  }

  methodDescriptorRunCrossExamination = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/RunCrossExamination',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.RunCrossExaminationRequest,
    cross_reference_pb.RunCrossExaminationResponse,
    (request: cross_reference_pb.RunCrossExaminationRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.RunCrossExaminationResponse.deserializeBinary
  );

  runCrossExamination(
    request: cross_reference_pb.RunCrossExaminationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.RunCrossExaminationResponse>;

  runCrossExamination(
    request: cross_reference_pb.RunCrossExaminationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.RunCrossExaminationResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.RunCrossExaminationResponse>;

  runCrossExamination(
    request: cross_reference_pb.RunCrossExaminationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.RunCrossExaminationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/RunCrossExamination',
        request,
        metadata || {},
        this.methodDescriptorRunCrossExamination,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/RunCrossExamination',
    request,
    metadata || {},
    this.methodDescriptorRunCrossExamination);
  }

  methodDescriptorGetCrossExamination = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossExamination',
    grpcWeb.MethodType.UNARY,
    cross_reference_pb.GetCrossExaminationRequest,
    cross_reference_pb.GetCrossExaminationResponse,
    (request: cross_reference_pb.GetCrossExaminationRequest) => {
      return request.serializeBinary();
    },
    cross_reference_pb.GetCrossExaminationResponse.deserializeBinary
  );

  getCrossExamination(
    request: cross_reference_pb.GetCrossExaminationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cross_reference_pb.GetCrossExaminationResponse>;

  getCrossExamination(
    request: cross_reference_pb.GetCrossExaminationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetCrossExaminationResponse) => void): grpcWeb.ClientReadableStream<cross_reference_pb.GetCrossExaminationResponse>;

  getCrossExamination(
    request: cross_reference_pb.GetCrossExaminationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cross_reference_pb.GetCrossExaminationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossExamination',
        request,
        metadata || {},
        this.methodDescriptorGetCrossExamination,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.crossref.CrossReferenceService/GetCrossExamination',
    request,
    metadata || {},
    this.methodDescriptorGetCrossExamination);
  }

}

